'use client';
import React, { useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import lottie, { type RendererType } from 'lottie-web';

// 简化为只暴露 play 方法的接口
export interface LottieRef {
  play: () => void;
}

const Lottie = forwardRef<
  LottieRef,
  {
    play: boolean;
    style?: any;
    loop?: boolean;
    name?: string;
    data: Record<string, any>;
  }
>(({ play, style, loop, name, data }, ref) => {
  const domRef = useRef<any>();
  const animRef = useRef<any>();

  // 只暴露 play 方法
  useImperativeHandle(
    ref,
    () => ({
      play: () => {
        if (animRef.current) {
          // 先重置到第一帧，然后播放
          animRef.current.goToAndPlay(0, true);
        }
      },
    }),
    [],
  );

  useEffect(() => {
    const params = {
      container: domRef.current as Element,
      renderer: 'svg' as RendererType,
      loop: loop ?? true,
      autoplay: true,
      name: name ?? '',
      animationData: data,
    };
    if (animRef.current) {
      // 如果当前有动画，先销毁
      animRef.current.destroy();
    }
    animRef.current = lottie.loadAnimation(params);
  }, [data]);

  useEffect(() => {
    if (animRef.current) {
      if (play) {
        animRef.current.play();
      } else {
        animRef.current.pause();
      }
    }
  }, [play]);

  return (
    <div style={style}>
      <div ref={domRef} />
    </div>
  );
});

Lottie.displayName = 'Lottie';

export { Lottie };
